export const COLORS = {
  PAPER: '#fafaf9',
  PAPER_DARK: '#eef1f4',
  TEXT: '#1a1a1a',
  INK: '#0e1c2b',
  PRIMARY: '#1890ff',
  PRIMARY_LIGHT: '#69c0ff',
  PRIMARY_DARK: '#0050b3',
  GOLD: {
    gold1: '#fffbe6',
    gold2: '#fff1b8',
    gold3: '#ffe58f',
    gold4: '#ffd666',
    gold5: '#ffc53d',
    gold6: '#faad14',
    gold7: '#d48806',
    gold8: '#ad6800',
    gold9: '#874d00',
    gold10: '#613400'
  }
};
